import React, { useState } from "react";
import moment from 'moment-timezone';
import { evvntEmailBlastSubscriberCounts } from "../../utils/config";
import closeIcon from "../../../../assets/images/icons/circle-x-filled.svg";

const DefaultEvent = ({
    event,
    eventPrice,
    handleEventCard,
    calculatePrice,
    selectedDate,
    setSelectedDate,
    minDate,
    implementations,
    handleSelectDate,
    selectedImplementation,
    setListSize,
    listSize
}) => {
  const isSelectedImpletentation = implementations.filter(i => event[i]?.is_selected)

  return (
    <div className="d-flex flex-column w-100 gap-4  ">
      <img
        src={closeIcon}
        className="close"
        alt="close icon"
        width="24"
        height="24"
        onClick={() => {
          handleEventCard(event, true);
        }}
      />

      <div className="card-head">
        <div className="d-flex align-items-center gap-3">
          <img
            src={event.banner_image}
            alt={event.name}
            width="106"
            height="63"
          />
          <h2 className="pl-3">{event.name}</h2>
        </div>
        {(event?.calculated_price || eventPrice[`${event.id}-evvnt_email_blast`]) > 0 ? (
            <div className="h4 p-3 event-price">
                ${event?.calculated_price || eventPrice[`${event.id}-evvnt_email_blast`]}
            </div>
        ) : ('')}
      </div>
      {implementations?.map((implementation, index) => (
        <div className="row card-select-container align-items-end" key={index}>
          {implementations?.length > 1 ? (
            <div className="col-12 col-sm-6 col-md-6 col-xl-3 pb-3">
              <label className="d-flex align-items-center cursor-pointer">
                <input
                  type="radio"
                  name={event.id}
                  id={`${event.id}-${implementation}`}
                  className="mr-2"
                  checked={selectedImplementation[event.id] === implementation}
                  onChange={() => handleSelectDate(event?.id, implementation)}
                />
                <span className="text-capitalize">
                  {event[implementation]?.title.split('_').join(' ')}
                </span>
              </label>
            </div>
          ) : ('')}

          <div className="col-12 col-sm-6 col-md-6 col-xl-3 form-group">
            <label className="mb-1">Schedule Your Email</label>

            <input
              type="datetime-local"
              placeholder="Choose A Date and Time"
              className={`bg-white form-control ${implementations?.length > 1 && (selectedImplementation[event.id] !== implementation) ? 'disabled-opacity' : ''}`}
              min={moment(minDate).tz(event?.timezone).format('YYYY-MM-DDTHH:mm')}
              max={
                event?.end_date
                  ? moment(event.end_date)
                      .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
                      .format('YYYY-MM-DDTHH:mm')
                  : undefined
              }
              value={selectedDate[`${event?.id}-${implementation}`] ? selectedDate[`${event?.id}-${implementation}`] : event[implementation]?.date ? moment(event[implementation]?.date).tz(event?.timezone).format('YYYY-MM-DDTHH:mm') : moment(minDate).tz(event?.timezone).format('YYYY-MM-DDTHH:mm')}
              onChange={(e) => {
                setSelectedDate({[`${event?.id}-${implementation}`]: e.target.value})

                if(listSize[`${event?.id}-${implementation}`]) {
                  calculatePrice({id: event.id, price: event[implementation]?.price, date: e.target.value}, listSize[`${event?.id}-${implementation}`], false, event[implementation].path);
                }
             }}
              disabled={implementations?.length > 1 && !(selectedImplementation[event.id] === implementation)}
            />
          </div>

          <div className="col-12 col-sm-6 col-md-6 col-xl-6 form-group">
            <label className="mb-1">List Size</label>
            <select
              className={`form-control bg-white ${implementations?.length > 1 && (selectedImplementation[event.id] !== implementation) ? 'disabled-opacity' : ''}`}
              onChange={(e) => {
                const selectedSize = e.target.value;

                setListSize(prev => ({
                  ...prev,
                  [`${event.id}-${implementation}`]: selectedSize
                }));

                calculatePrice(
                  { id: event.id,
                    price: event[implementation]?.price,
                    date: selectedDate[`${event?.id}-${implementation}`] ? selectedDate[`${event?.id}-${implementation}`] : minDate
                  },
                  e.target.value,
                  false,
                  event[implementation].path
                );

              }}
              value={listSize[`${event.id}-${implementation}`] ?? ''}
              disabled={implementations?.length > 1 && selectedImplementation[event.id] !== implementation}
            >
              <option value="" disabled>
                How Many Subscribers Do You Want To Email?
              </option>

              {evvntEmailBlastSubscriberCounts?.map((count, index) => (
                <option value={count} key={index}>
                  {count}
                </option>
              ))}
            </select>

          </div>
        </div>
      ))}
    </div>
  );
};

export default DefaultEvent;
